
export function ReadOnlyValue(props: {
    className?: string,
    children?: any,
}) {
    const noValueMessage = (!props.children) ? <div className="tag subtle">Not entered</div> : undefined;

    return (
        <div
            className={[props.className, "form-control read-only-value"].join("")}
        >
            {props.children}
            {noValueMessage}
        </div>
    );

}
